import store from '@/store'
import {
  mountVueInstance,
  renderThemeFromCssUrl,
  setLanguage as setLanguageInternal
} from 'dolphin-plugin-tools'
import App from './loginApp'
import i18n from '../i18n'
import huiLocale from 'hui/lib/locale'
import API from 'api/api'
import storage from 'good-storage'
import Router from 'vue-router'
// TODO:默认加入样式，后续待删除
import 'hui/lib/hui.css'
import axios from 'axios'
import loginApp from '../pages/login/login'

let assetsUrl = process.env.BASE_URL + process.env.VUE_APP_ASSETS


async function initApp (Vue) {
  try {
    let { userInfo } = await store.dispatch('setUserInfo')
    // 设置主题,多语言
    await Promise.all([
      _getSystemName(),
      renderTheme(userInfo),
      setLanguage(userInfo)
    ])
    // 初始化vue实例
    mountVueInstance(Vue, App, {
      store,
      i18n,
      component:loginApp
    })
  } catch (error) {
    // 错误处理
    console.log(error)
  }
}
// 设置浏览器tab名称
function _getSystemName () {
  let systemName = storage.get('systemName')
  // if storage has system name
  document.getElementById('wiportalTitle').innerText = systemName
  // else get system name in api
  API.theme
    .query()
    .then(res => {
      if (res.data && res.data.systemName) {
        document.getElementById('wiportalTitle').innerText = res.data.systemName
        // and save to storage
        storage.set('systemName', res.data.systemName)
      }
    })
    .catch(err => {
      console.log(err)
      this.$message.error(err.msg)
    })
}

async function renderTheme ({ skin }) {
  try {
    // public/static/skin/xxx/skin.css
    const requestUrl = `${assetsUrl}/skin/${skin}/skin.css`
    await renderThemeFromCssUrl(requestUrl)
  } catch (error) {
    // 设置自定义皮肤失败, 但是由于默认皮肤的存在, 可以继续初始化Vue实例
    // console.error('设置自定义皮肤失败')
  }
}

async function setLanguage ({ languageId }) {
  // public/static/i18n/xxx/index.json
  const requestUrl = `${assetsUrl}/i18n/${languageId}/index.json`
  let i18nJson = null
  let flag = true
  await axios.get(requestUrl).then(res => {
    i18nJson = res
  }).catch(async err => {
    console.log(err)
    flag = false
    i18nJson = await axios.get(`${assetsUrl}/i18n/en_US/index.json`)
  })

  // if (!i18nJson) i18nJson = await axios.get(`${assetsUrl}/i18n/en_US/index.json`)
  await setLanguageInternal(i18nJson.data, flag ? languageId : 'en_US', huiLocale, i18n)
  let widgetRequestUrl = []
  let displayBoardRequestUrl = await API.common.getLanguageInfo()
  let waterfallRequestUrl = await API.common.getPortalLanguageInfo()
  widgetRequestUrl = widgetRequestUrl.concat(
    waterfallRequestUrl.data,
    displayBoardRequestUrl.data
  )
  for (let i = 0; i < widgetRequestUrl.length; i++) {
    let item = widgetRequestUrl[i]
    try {
      let widgetI18n = await axios.get(`${item.url}/${languageId}/index.json`)
      if (widgetI18n) {
        item.list.forEach(key => {
          let temp = {}
          temp[key] = widgetI18n.data[key]
          Object.assign(i18nJson.data, temp)
        })
        for (let i = 0; i < item.list.length; i++) {
          let _key = item.list[i]
          let widgetI18nData = widgetI18n.data
          for (let key in widgetI18nData) {
            if (key.indexOf(_key) > -1) {
              i18nJson.data[key] = widgetI18nData[key]
            }
          }
        }
      }
    } catch (e) {
    }
  }
  await setLanguageInternal(i18nJson.data, flag ? languageId : 'en_US', huiLocale, i18n)
}

export default initApp
